import Requirement from "./Requirement";

export default Requirement;
